module.exports = __webpack_public_path__ + "static/media/ic_right.58337f98.svg";